module.exports = __webpack_public_path__ + "img/product_94.c89fc82.svg";